const isPlatformTeamMember = (mobile: string) => {
    const platformTeamMemberMoblieList = ['01058513100', '01091201947', '01096711000', '01088607633', '01093805627']
    return platformTeamMemberMoblieList.includes(mobile || '');
}

export { isPlatformTeamMember }